<div class="markdown-container" [innerHTML]="htmlContent"></div>
